/**
 * Created by mykurisu on 2017/11/9.
 */
import React from 'react'
import axios from 'axios'
import {connect} from 'react-redux'
import { browserHistory } from 'react-router'
import no1Img from '../../images/schedule/no1.png'
import no2Img from '../../images/schedule/no2.png'
import no3Img from '../../images/schedule/no3.png'
import emptyImg from '../../images/schedule/rank-empty.png' 
import {WKInfiniteScroll, WKVisible, WKBottomBtn} from '../../components/wk'


class ScheduleRankPage extends React.Component {
    constructor (props) {
        super(props)
        this.state = {
            schedule: {},
            ranks: [],
            hasMore: true,
            offset: 0,
            share_info: {},
            isPending: false,
            myRank: {},
            stats: {},
            participate: false,
            isScheduleInfoReady: false,
            signin_info: null,
        }
    }
    componentDidMount () {
        document.title = '打卡排行榜'
        this.fetchData()
        this.fetchSchedule()
    }
    fetchSchedule () {
        axios.get(`/api/schedule/${this.props.params.id}/info`)
            .then(res => {
                const data = res.data.data
                this.setState({
                    participate: data.access_info && data.access_info.participate,
                    isScheduleInfoReady: true,
                    signin_info: data.signin_info,
                })
            })
    }
    getBottomText (ranks) {
        return ranks.length > 0 ? '邀请好友一起成长' : '立即打卡'
    }
    onClickBottomBtn (ranks) {
        if (ranks.length > 0) {
            location.assign(`/schedule/${this.props.params.id}/sharecard`)
        } else {
            // 因为安卓可能会发生sdk加载失败的情况
            if (window.systemType === 'android') {
                location.assign(`/schedule/${this.props.params.id}/signin/create`)
            } else {
                location.assign(`/schedule/${this.props.params.id}/signin/create`)
            }
        }
    }
    fetchData () {
        this.setState({ isPending: true })
        axios.get(`/api/schedule/${this.props.params.id}/rank`, {
            params: {
                offset: this.state.offset,
            }
        })
            .then(res => {
                this.setState({ 
                    isPending: false,
                    schedule: res.data.data.schedule,
                    ranks: this.state.ranks.concat(res.data.data.ranks),
                    hasMore: res.data.data.has_more,
                    offset: res.data.data.next_offset,
                    share_info: res.data.data.share_info,
                    myRank: res.data.data.my_rank,
                    stats: res.data.data.stats,
                })
            })
    }
    renderNum (i) {
        if (i === 0) {
            return <img src={no1Img} />
        }
        if (i === 1) {
            return <img src={no2Img} />
        }
        if (i === 2) {
            return <img src={no3Img} />
        }
        return <span>{i + 1}</span>
    }
    toShareCard () {
        location.assign(`/schedule/${this.props.params.id}/sharecard`)
    }
    toSignin () {
        // 因为安卓可能会发生sdk加载失败的情况
        if (window.systemType === 'android') {
            location.assign(`/schedule/${this.props.params.id}/signin/create`)
        } else {
            location.assign(`/schedule/${this.props.params.id}/signin/create`)
        }
    }
    getEmptyContent (process, participate, signin_info) {
        if (process === 'close') {
            return (
                <div>
                    <p>当前活动暂无用户打卡</p>
                </div>
            )
        }
        if (participate && process === 'starting' && !signin_info) {
            return (
                <div>
                    <p>点击下方按钮立即打卡</p>
                    <p>强势上榜</p>
                </div>
            )
        } else {
            return (
                <div>
                    <p>返回打卡活动页</p>
                    <p>参与打卡，强势上榜</p>
                </div>
            )
        }
    }
    render() {
        const { ranks, schedule, signin_info, participate } = this.state
        const process = schedule.process
        return (
            <div className={`schedule-rank-page wk-page ${ranks.length > 0 ? '' : 'is-empty'}`}>
                <div className="rank__top">
                    <div className="top__bg"></div>

                    <div className="top__title text-ellipsis">
                        {this.state.schedule.name}
                    </div>

                    <div className="top__messagecard">
                        <div className="messagecard__avatar" style={{backgroundImage: `url(${this.props.account.avatar_url})`}}>

                        </div>
                        <div className="messagecard__name text-ellipsis">
                            {this.props.account.nickname}
                        </div>
                        <div className="messagecard__content">
                            <div className="content__item">
                                <div className="item__title">
                                    打卡排名
                                </div>
                                <div className="item__num">
                                    {this.state.myRank.rank}
                                </div>
                            </div>

                            <div className="content__item">
                                <div className="item__title">
                                    打卡总数
                                </div>
                                <div className="item__num">
                                    {this.state.myRank.cumulative_days}
                                </div>
                            </div>
                        </div>
                    </div>
                </div>

                <WKVisible create={ranks.length > 0}>
                    <div className="rank__total">
                        打卡总人数：{this.state.stats.signin_count}人
                    </div>
                </WKVisible>

                <WKVisible create={this.state.schedule.bonus_flag && ranks.length > 0}>
                    <div className="condition">
                        奖金领取条件：至少打卡{this.state.schedule.bonus_condition_day}次
                    </div>
                </WKVisible>
                

                <div className="rank__list">
                    {
                        this.state.ranks.map((item, i) => (
                            <div className="list__item" key={item.account.id}>
                                <div className="item__name">
                                    <div className="name__num">
                                        {this.renderNum(i)}
                                    </div>
                                    <div className="name__icon" style={{backgroundImage: `url(${item.account.avatar_url})`}}>
                                        
                                    </div>
                                    <div className="name__text">
                                        {item.account.nickname}
                                    </div>
                                </div>
                                <div className="item__num">
                                    {item.cumulative_days}次
                                </div>
                            </div>
                        ))
                    }
                </div>
                    
                <WKVisible create={ranks.length === 0 && !this.state.isPending} className='empty-wrap'>
                    <div className="empty-content">
                        <img src={emptyImg} alt="列表为空"/>
                        <div className="text">
                            {
                                this.getEmptyContent(process, participate, signin_info)
                            }
                        </div>
                    </div>
                </WKVisible>
                
                {/* 底部按钮 */}
                <WKVisible show={this.state.isScheduleInfoReady && process !== 'close'}>
                    <WKVisible show={process === 'not_start' && participate}>
                        <WKBottomBtn btnContent={{
                            text: '邀请好友，一起成长',
                            method: () => this.toShareCard()
                        }} />
                    </WKVisible>
                    <WKVisible show={process === 'starting' && participate && !signin_info}>
                        <WKBottomBtn btnContent={{
                            text: '立即打卡',
                            method: () => this.toSignin()
                        }} />
                    </WKVisible>
                    <WKVisible show={process === 'starting' && participate && signin_info}>
                        <WKBottomBtn btnContent={{
                            text: '邀请好友，一起成长',
                            method: () => this.toShareCard()
                        }} />
                    </WKVisible>
                </WKVisible>
                    
                <WKInfiniteScroll 
                    onTouchBottom={() => this.fetchData()}
                    isStop={this.state.isPending}
                    isKill={!this.state.hasMore}
                    isShowLoading={true}
                />
            </div>
        )
    }
}


export default connect(state => ({
    account: state.account
}))(ScheduleRankPage)


// WEBPACK FOOTER //
// ./src/pages/schedule/ScheduleRankPage.js